module.exports = __webpack_public_path__ + "static/edeq.041218ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medicare/edeq.png
// module id = 766
// module chunks = 129662963943619 142354426033121